export default __webpack_public_path__ + "static/chat-indy-f67a255316ce78111385fa448fdcae8a.jpg";